var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{staticClass:"ninja",attrs:{"id":"ninja","width":"370","height":"530"},on:{"click":function($event){return _vm.touch()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }